// extracted by mini-css-extract-plugin
export default {"header":"Header_header__sJ-qh","row":"Header_row__CMgIf","logoTitle":"Header_logoTitle__CJaMY","cart-button":"Header_cart-button__RefTE","quantity":"Header_quantity__hcL4s"};